<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <h1 class="is-title-header modal-card-title">Test Run</h1>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <b-field label="Customer">
                <b-select
                  expanded
                  name="customer"
                  v-model="form.customer"
                  placeholder="Please select"
                  required
                  v-if="parentCustomer"
                >
                  <option
                    v-for="(option, index) in parentCustomer"
                    :value="option.id"
                    :key="index"
                    selected
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Country">
                <b-select
                  expanded
                  name="country"
                  v-model="form.country"
                  v-on:input="filterScheme"
                  placeholder="Please select"
                  required
                >
                  <option
                    v-for="(option, index) in countryListArray"
                    :value="option.id"
                    :key="index"
                    selected
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Scheme">
                <b-select
                  expanded
                  name="scheme"
                  v-model="form.scheme"
                  v-on:input="filterStream"
                  placeholder="Please select"
                  required
                >
                  <option
                    v-for="(option, index) in schemeLists"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Stream">
                <b-select
                  expanded
                  name="stream"
                  v-model="form.stream"
                  placeholder="Please select"
                  v-on:input="filterReports"
                  required
                >
                  <option
                    v-for="(option, index) in containerLists"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Report Definition">
                <b-select
                  expanded
                  name="report"
                  v-model="form.report_definition"
                  placeholder="Please select"
                  required
                  v-on:input="checkValues"
                >
                  <option
                    v-for="(option, index) in reports"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Period">
                <b-input
                  v-model="form.period"
                  v-on:input="checkValues"
                  required
                ></b-input>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button
            slot="right"
            native-type="submit"
            type="is-primary"
            :disabled="disableOKButton"
          >
            OK
          </b-button>
          <b-button slot="right" type="is-normal" @click="cancel">
            Cancel
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import RulesManagerService from "../../services/RulesManagerService";
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
//import Multiselect from "vue-multiselect";
import scopeMixin from "@/mixins/scopeMixin";
export default {
  name: "GenerateTestRunModal",
  mixins: [UtilityMixin, scopeMixin],
  // components: {
  //   Multiselect
  // },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    parentCustomer: {
      type: Array
    },
    schemeListArray: {
      type: Array
    },
    countryListArray: {
      type: Array
    },
    containerListArray: {
      type: Array
    }
  },

  data() {
    return {
      form: {},
      reports: [],
      isModalActive: false,
      loading: "",
      disableOKButton: false,
      RulesManagerService: new RulesManagerService(),
      reportingTrackerService: new ReportingTrackerDataService(),
      schemeLists: this.schemeListArray,
      containerLists: this.containerListArray
    };
  },
  mounted() {
    this.checkValues();
    this.fetchReportingTrackerData();
  },
  methods: {
    fetchReportingTrackerData() {
      this.reportingTrackerService.getAllReports().subscribe(
        response => {
          this.reports = response;
        },
        e => {
          console.log(e);
        }
      );
    },

    filterScheme(country) {
      this.form.scheme = null;
      this.form.stream = null;
      this.form.report_definition = null;
      this.form.period = "";
      this.schemeDataService.getByCountry(country).subscribe(
        response => {
          this.schemeLists = response;
        },
        e => {
          console.log(e);
        }
      );

      this.checkValues();
    },
    filterReports(stream) {
      this.form.period = "";
      this.RulesManagerService.getFilterReportDefition(
        this.form.country,
        this.form.scheme,
        stream
      ).subscribe(
        response => {
          this.reports = response;
        },
        e => {
          console.log(e);
        }
      );

      this.checkValues();
    },
    filterStream(scheme) {
      this.form.stream = null;
      this.form.report_definition = null;
      this.form.period = "";
      this.schemeDataService.get(scheme).subscribe(
        response => {
          this.containers = response["container"];
          this.containerLists = this.containers.filter(
            e => e.name !== "General"
          );
        },
        e => {
          console.log(e);
        }
      );
    },
    cancel() {
      this.disableOKButton = true;
      this.$emit("cancel");
    },

    submit() {
      this.$emit("confirm", this.form);
    },
    checkValues() {
      if (this.form.period && this.form.report_definition > 0) {
        this.disableOKButton = false;
      } else {
        this.disableOKButton = true;
      }
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
